export default "__VITE_ASSET__Nikl0YqD__"